import React, { useEffect, useState } from "react";
import { useForm } from "../../../../../Hooks/UseForm";
import { RadioGroup } from "@headlessui/react";
import {
  formTarjetaCredito,
  optionAnoMercantil,
  optionMes,
} from "../../../../../propsType/Payemnts";
import { validatePagoTarjetaCredito } from "../../../../../validations/formValidations";
import InputGeneric from "../../../../../components/Inputs/InputGeneric";
import ButtonGeneric from "../../../../../components/Buttons/ButtonGeneric";
import bills from "../../../../../assets/png/bill.png";
import question from "../../../../../assets/png/question-mark.png";
import "../../../../css/steps.css";
import PagosController from "../../../../../controllers/PagosController";
import { UseContextApp } from "../../../../../Global/Context/appContext";
import { TrashIcon } from "@heroicons/react/outline";
import Spinner from "../../../../../components/Loading/loadingSpinner/Spinner";
import Modal from "../../../../../components/Modals/Modal";
import CreditCardForm from "../../../../../components/CrediCard/Card";
import { colors } from "../../../../../propsType/Colors";
import visa from "../../../../../assets/bancos/visa-50.jpg";
import mastercard from "../../../../../assets/bancos/mastercard-50.jpg";
import SelectGeneric from "../../../../../components/Inputs/SelectGeneric";
import moment from "moment";

const card = [
  {
    id: 1,
    number: "4716050884895568",
    fecha: "09/2025",
    icon: TrashIcon,
    token: "123456789",
  },
  {
    id: 2,
    number: "4716827632209485",
    fecha: "07/2023",
    icon: TrashIcon,
    token: "123456789",
  },
  {
    id: 3,
    number: "5519736993204488",
    fecha: "02/27",
    icon: TrashIcon,
    token: "123456789",
  },
];
function TarjetaCreditoEX({
  data,
  setData,
  stapsState,
  setStapsState,
  back,
  deatils,
}) {
  const {
    getTarjetaMercantil,
    pagoTokenMercantil,
    deleteTarjetaMercantil,
    pagoTDCMercantil,
    solicitarOtp,
  } = PagosController();
  const [{ user }, dispatch] = UseContextApp();
  const [activeForm, setActiveForm] = useState(false);
  const [activeCard, setActiveCard] = useState(false);
  const [tarjetas, setTarjetas] = useState([""]);
  const [selected, setSelected] = useState(
    activeForm ? [""] : tarjetas?.lTarjeta
  );
  const [value, setValue] = useState("");
  const [modal, setModal] = useState(false);
  const [message, setMessage] = useState("");
  const [itemDelete, setItemDelete] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingCard, setLoadingCard] = useState(false);
  const [loadingModal, setLoadingModal] = useState(false);
  const [img, setImg] = useState("");
  const [shoeModal, setShoeModal] = useState(false);
  const [icon, setIcon] = useState(false);
  const [infoCard, setInfoCard] = useState(null);
  const [modalCard, setModalCard] = useState(false);
  const [deleteCheck, setDeleteCheck] = useState(false);
  const [terminos, setTerminos] = useState(null);
  const [errorTerminos, setErrorTerminos] = useState(false);
  const [emailCliente, setEmailCliente] = useState(user?.datos?.email);
  const [fechaNow, setFechaNow] = useState(moment().format("YYYY-MM-DD"));
  const [showNroTDC, setShowNroTDC] = useState(false);
  const [showCVV, setShowCVV] = useState(false);

  const [sendSms, setSendSms] = useState(true);
  const [sendEmail, setSendEmail] = useState(false);
  const [loadingOtp, setLoadingOtp] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [paymentModal, setPaymentModal] = useState(false);
  const [paymentCheck, setPaymentCheck] = useState(false);
  const [paymentMessage, setPaymentMessage] = useState("");

  const { form, setForm, errors, setErrors, handleChange, handleSubmit, handleBlur } = useForm(formTarjetaCredito, validatePagoTarjetaCredito, activeForm, emailCliente);
  const handleTerminos = (e) => {
    setTerminos(e.target.checked);
  };

  const handleSolicitarOtp = async () => {
    if (!sendSms && !sendEmail) {
      setIcon(false);
      setMessage("Debe seleccionar al menos un método de envío (SMS o Correo).");
      setShoeModal(true);
      return;
    }

    try {
      setLoadingOtp(true);
      const emailRaw = user?.datos?.email || user?.email || "";
      const correoBase64 = emailRaw ? btoa(unescape(encodeURIComponent(emailRaw))) : "";
      const payload = {
        docIdentidad: (user?.datos?.docIdentificacion || user?.id || user?.idCliente || "").toString(),
        tipoOtp: 1,
        correo: correoBase64,
      };

      if (sendSms && !sendEmail) {
        payload.canal = "sms";
      } else if (!sendSms && sendEmail) {
        payload.canal = "correo";
      }

      const res = await solicitarOtp(payload);
      setLoadingOtp(false);

      if (res?.respuesta === "0" || res?.codigo === "0" || res?.codRespuesta === "0") {
        setPaymentCheck(true);
        setPaymentMessage(res.descripcion || "Para continuar, hemos enviado un código de seguridad.");
        setPaymentModal(true);
        setOtpSent(true);
      } else {
        setPaymentCheck(false);
        setPaymentMessage(res?.descripcion || "Ha ocurrido un error al solicitar el código OTP. Intente nuevamente.");
        setPaymentModal(true);
      }
    } catch (error) {
      setLoadingOtp(false);
      setPaymentCheck(false);
      setPaymentMessage("Ha ocurrido un error al procesar la solicitud de OTP.");
      setPaymentModal(true);
    }
  };

  const pagar = async () => {
    if (terminos) {
      setErrorTerminos(false);
      if (!activeForm && activeCard) {

        const result = handleSubmit();
        if (result === "ok") {
          setLoading(true);
          let dateCard = selected.fechaVencimiento.replace(/\//g, "");
          let dataToken = {
            nombreCliente: form.name,
            nroTarjeta: selected.tarjeta,
            fechaVen: dateCard,
            monto: data.metodoAPagar,
            transaccion: Math.round(Math.random() * 10000000000),
            cvv: form.cvvCard,
            email: emailCliente,
            cuenta: deatils.nroCuenta,
            idAbonado: user.idCliente,
            docIdentidad: user?.datos?.docIdentificacion,
            token: selected.token,
            otp: form.otp,
          };
          const res = await pagoTokenMercantil(dataToken);
          switch (res.respuesta) {
            case "0":
              setLoading(false);
              setStapsState({
                ...stapsState,
                option1: false,
                option2: false,
                option3: false,
                option4: false,
                option5: true,
              });
              setData({ ...data, transaccion: dataToken.transaccion, email: dataToken.email, monto: dataToken.monto, fecha: fechaNow });
              break;
            default:
              setLoading(false);
              setPaymentCheck(false);
              if (res?.code == 3) {
                setPaymentMessage("Por favor, verifica los dígitos del código que recibiste e ingrésalo nuevamente.");
              } else if (res?.code == 4) {
                setPaymentMessage("Has completado las 3 transacciones permitidas. Puedes intentarlo nuevamente el próximo mes.");
              } else {
                setPaymentMessage(res?.descripcion || "Ha ocurrido un error inesperado, por favor inténtelo de nuevo...");
              }
              setPaymentModal(true);
              break;
          }
        }
      }
      if (activeForm && !activeCard) {
        const result = handleSubmit();
        if (result === "ok") {
          let ano = form.year.slice(form.year.length - 2);
          setLoading(true);

          let dataTDCMercantil = {
            nombreCliente: form.name,
            nroTarjeta: form.numberCardCredit,
            fechaVen: form.month + ano,
            monto: data.metodoAPagar,
            cvv: form.cvvCard,
            email: emailCliente,
            cuenta: deatils.nroCuenta,
            idAbonado: user.idCliente,
            docIdentidad: user?.datos?.docIdentificacion,
            transaccion: Math.round(Math.random() * 10000000000),
            otp: form.otp,
          };
          const res = await pagoTDCMercantil(dataTDCMercantil);
          switch (res.respuesta) {
            case "0":
              setData({ ...data, transaccion: dataTDCMercantil.transaccion, email: dataTDCMercantil.email, monto: dataTDCMercantil.monto, fecha: fechaNow });
              setLoading(false);
              setStapsState({
                ...stapsState,
                option1: false,
                option2: false,
                option3: false,
                option4: false,
                option5: true,
              });
              break;
            default:
              setPaymentCheck(false);
              if (res?.code == 3) {
                setPaymentMessage("Por favor, verifica los dígitos del código que recibiste e ingrésalo nuevamente.");
              } else if (res?.code == 4) {
                setPaymentMessage("Has completado las 3 transacciones permitidas. Puedes intentarlo nuevamente el próximo mes.");
              } else {
                setPaymentMessage(res?.descripcion || "Ha ocurrido un error inesperado, por favor inténtelo de nuevo...");
              }
              setPaymentModal(true);
              setLoading(false);
              break;
          }
        }
      }
    } else { setErrorTerminos(true); }
  };
  const getTarjetas = async () => {
    setLoadingCard(true);
    let dataGetTarjetaMercantil = {
      docIdentidad: user.id,
      idCliente: user.idCliente,
    };
    const resGet = await getTarjetaMercantil(dataGetTarjetaMercantil);
    if (resGet) {
      setLoadingCard(false);
      setTarjetas(resGet);
    } else { setLoadingCard(false); }

  };
  const deleteTarjeta = async (item) => {
    setShoeModal(true);
    if (item === "borrar") {
      setInfoCard(null);
      setLoadingModal(true);
      let data = {
        docIdentidad: user.id,
        idCliente: user.idCliente,
        token: itemDelete.token,
      };
      const resDelete = await deleteTarjetaMercantil(data);
      if (resDelete.codRespuesta === "0") {
        setLoadingModal(false);
        setShoeModal(true);
        setDeleteCheck(true);
        setMessage(resDelete.descRespuesta);
      } else {
        setLoadingModal(false);
        setMessage("Ha ocurrido un error al eliminar la tarjeta. Intente nuevamente");
        setIcon(false);
      }
    } else {
      item.number && setInfoCard(item);
      setItemDelete("");
      setItemDelete(item);
      setImg(question);
      setIcon(true);
      setDeleteCheck(false);
      setMessage("¿Realmente desea eliminar la información de esta tarjeta?");
    }
  };
  const handle = (e) => {
    if (e.target.value === "add") {
      setActiveForm(true);
      setActiveCard(false);
      setForm({ ...form, cvvCard: "", email: "" });
    }
  };

  const changeOptions = (string) => {
    if (string === "card") {
      setForm({
        ...form,
        name: "",
        numberCardCredit: "",
        year: "",
        month: "",
        cvvCard: "",
        email: "",
      });
      setActiveCard(true);
      setModalCard(false);
      setActiveForm(false);
    }
  };

  useEffect(() => {
    if (activeCard) {
      setErrors({
        errors,
        name: "",
        numberCardCredit: "",
        cvvCard: "",
        email: "",
        year: "",
        month: "",
      });
    }
  }, [activeCard]);

  useEffect(() => { getTarjetas(); }, [shoeModal]);

  useEffect(() => {
    if (terminos) {
      setErrorTerminos(false);
    }
  }, [terminos]);

  const funtionShowCVV = () => { setShowCVV(!showCVV); };
  const funtionShowNroTDC = () => { setShowNroTDC(!showNroTDC); };
  function classNames(...classes) { return classes.filter(Boolean).join(" "); }
  return (
    <>
      <div className="flex lg:pt-[150px] pt-[240px] p-6  md:pt-[241px] flex-col-reverse lg:flex-row lg:px-[28px] gap-[7rem] lg:pb-6 lg:gap-4 relative">
        <div className="absolute left-0 top-0 w-full ">
          <div className="bg-white w-full px-4 py-5 border-b border-gray-200 sm:px-6">
            <div className="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
              <div className="ml-4 mt-4">
                <h3 className="text-2xl leading-6 font-medium text-gray-900">
                  Tarjeta Internacional
                </h3>
                <p className="mt-1 text-sm text-gray-500">
                  Completa la información y haz clic en pagar
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="lg:w-[70%]  ">
          {loading ? (
            <>
              <div className="w-full h-full flex justify-center items-center">
                <Spinner title={"Espere por favor..."} />
              </div>
            </>
          ) : (
            <>
              <div className="h-full flex flex-col lg:gap-[20px] justify-between ">
                <div className="h-[80%] relative  gap-[10%] lg:top-[-160px] top-[-234px] flex flex-col justify-start ">
                  <div className="flex flex-col-reverse relative  top-[135px] lg:flex-row justify-between lg:gap-8">
                    <div className="w-full ">
                      <div className="pb-[15px] ">
                        <input
                          type="radio"
                          name="typeForm"
                          checked={activeForm}
                          value={"add"}
                          onChange={handle}
                        />
                        <label htmlFor="" className="ml-5">
                          Pagar y Registrar una Nueva Tarjeta.
                        </label>
                      </div>
                      <div className="flex flex-col gap-5">
                        <div>
                          <InputGeneric
                            type={"text"}
                            disable={!activeForm}
                            title={
                              "Nombre del Titular de la Tarjeta de Crédito"
                            }
                            name={"name"}
                            handleBlur={handleBlur}
                            onChange={handleChange}
                            errorText={errors.name}
                            value={form.name}
                          />
                        </div>
                        <div>
                          <InputGeneric
                            disable={!activeForm}
                            title={"Número de Tarjeta de Crédito"}
                            name={"numberCardCredit"}
                            handleBlur={handleBlur}
                            onChange={handleChange}
                            errorText={errors.numberCardCredit}
                            value={form.numberCardCredit}
                            type={showNroTDC ? "text" : "password"}
                            show={showNroTDC}
                            funtionShow={funtionShowNroTDC}
                            maxValue={16}
                          />
                        </div>
                        <div className="flex gap-2 ">
                          <div className="grid w-full ">
                            <div className="text-sm font-medium text-gray-900">
                              Mes de Vencimiento
                            </div>
                            <div className="grid !mt-1 ">
                              <SelectGeneric
                                onChange={handleChange}
                                value={form.month}
                                name={"month"}
                                onBlur={handleBlur}
                                errors={errors.month}
                                selectData={optionMes}
                                disabled={!activeForm}
                              />
                            </div>
                          </div>
                          <div className="grid w-full ">
                            <div className="text-sm font-medium text-gray-900">
                              Año de Vencimiento
                            </div>
                            <div className="grid !mt-1 ">
                              <SelectGeneric
                                onChange={handleChange}
                                value={form.year}
                                name={"year"}
                                onBlur={handleBlur}
                                errors={errors.year}
                                selectData={optionAnoMercantil}
                                disabled={!activeForm}
                              />
                            </div>
                          </div>
                        </div>
                        <div>
                          <InputGeneric
                            title={"CVV"}
                            titleRequired={activeCard && "Requerido"}
                            name={"cvvCard"}
                            handleBlur={handleBlur}
                            onChange={handleChange}
                            errorText={errors.cvvCard}
                            value={form.cvvCard}
                            type={showCVV ? "text" : "password"}
                            show={showCVV}
                            funtionShow={funtionShowCVV}
                            maxValue={3}
                          />
                        </div>
                        <div>
                          <InputGeneric
                            title={"Correo Electrónico"}
                            titleRequired={activeCard && "Requerido"}
                            name={"email"}
                            handleBlur={handleBlur}
                            onChange={e => setEmailCliente(e.target.value)}
                            errorText={errors.email}
                            value={emailCliente}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="w-full">
                      {loadingCard ? (
                        <>
                          <div className="w-full h-full flex justify-center items-center">
                            <span className="parpadea text">
                              <strong>Cargando Tarjetas...</strong>
                            </span>
                          </div>
                        </>
                      ) : (
                        <>
                          {tarjetas?.lTarjeta?.length > 0 ? (
                            <>
                              <div className="pb-[10px] pt-5  lg:pt-0">
                                {" "}
                                Mis Tarjetas registradas
                              </div>
                              <RadioGroup
                                value={selected}
                                onChange={setSelected}
                                className="mt-1 overflow-y-auto lisCard h-auto pb-4 lg:h-[300px] pr-3"
                              >
                                <RadioGroup.Label className="sr-only">
                                  Pricing plans
                                </RadioGroup.Label>
                                <div className="relative bg-white grid gap-5  rounded-md -space-y-px">
                                  {tarjetas?.lTarjeta?.map((plan, planIdx) => (
                                    <RadioGroup.Option
                                      key={planIdx}
                                      value={plan}
                                      disabled={activeForm}
                                      className={({ checked }) =>
                                        classNames(
                                          planIdx === 0
                                            ? "rounded-tl-md rounded-tr-md"
                                            : "",
                                          planIdx === card.length - 1
                                            ? "rounded-bl-md rounded-br-md"
                                            : "",
                                          checked && !activeForm
                                            ? "bg-indigo-50 border-indigo-200 z-10"
                                            : "border-gray-200",
                                          "relative border p-4   md:pl-4 md:pr-6 focus:outline-none cursor-pointer"
                                        )
                                      }
                                    >
                                      {({ active, checked }) => (
                                        <>
                                          <div
                                            className="flex items-center justify-between text-lg"
                                            onClick={() =>
                                              changeOptions("card")
                                            }
                                          >
                                            <div className="flex items-center justify-between ">
                                              <span
                                                className={classNames(
                                                  checked && !activeForm
                                                    ? "bg-[#5AB9E5] border-transparent"
                                                    : " border-gray-300 bg-white ",
                                                  active && !activeForm
                                                    ? "ring-2 ring-offset-2 ring-[#5AB9E5] "
                                                    : "",
                                                  "h-4 w-4 rounded-full border flex items-center justify-center "
                                                )}
                                                aria-hidden="true"
                                              >
                                                <span className="rounded-full bg-white w-1.5 h-1.5" />
                                              </span>
                                              <RadioGroup.Label
                                                as="span"
                                                className={classNames(
                                                  checked && !activeForm
                                                    ? "text-indigo-900"
                                                    : "text-gray-400",
                                                  "ml-3 font-medium"
                                                )}
                                              >
                                                {plan?.tarjeta}
                                              </RadioGroup.Label>
                                            </div>
                                            <RadioGroup.Description
                                              as="span"
                                              className=" text-lg font-medium text-gray-900"
                                            >
                                              <span
                                                className={classNames(
                                                  checked && !activeForm
                                                    ? "text-indigo-900"
                                                    : "text-gray-400",
                                                  "ml-3 font-medium"
                                                )}
                                              >
                                                {plan?.fechaVencimiento}
                                              </span>
                                            </RadioGroup.Description>
                                            <RadioGroup.Description
                                              as="span"
                                              className=" text-lg font-medium text-gray-900"
                                            >
                                              <TrashIcon
                                                onClick={() =>
                                                  deleteTarjeta(plan)
                                                }
                                                className={`flex-shrink-0 h-6 w-6 hover:w-7 hover:h-7  transition-all duration-500 text-[${colors.lightBlue}] hover:text-red-500`}
                                                aria-hidden="true"
                                              />
                                            </RadioGroup.Description>
                                          </div>
                                        </>
                                      )}
                                    </RadioGroup.Option>
                                  ))}
                                </div>
                              </RadioGroup>
                            </>
                          ) : (
                            <>
                              <div className="w-full h-full font-medium text-[#09101F] flex justify-center items-center ">
                                <p>
                                  {" "}
                                  <strong>No hay tarjetas en el registro</strong>{" "}
                                </p>
                              </div>
                            </>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* Sección Método de Envío OTP */}
                <div className="flex flex-col gap-2 pt-2">
                  <div className="text-sm font-medium text-gray-900">
                    Seleccione el método de envío de OTP:
                  </div>
                  <div className="flex flex-col gap-3 mt-1">
                    <label className="flex items-center gap-3 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={sendSms}
                        onChange={(e) => setSendSms(e.target.checked)}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded cursor-pointer"
                      />
                      <span className="text-sm font-normal text-gray-700 min-w-[160px]">
                        Teléfono (SMS)
                      </span>
                      <span className="text-sm font-medium text-gray-800 tracking-wide">
                        {user?.datos?.maskTelefono || (user?.datos?.telefono ? user.datos.telefono.replace(/(\d{4})\d+(\d{2})/, "$1-****$2") : "+58 424 *** **12")}
                      </span>
                    </label>
                    <label className="flex items-center gap-3 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={sendEmail}
                        onChange={(e) => setSendEmail(e.target.checked)}
                        className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded cursor-pointer"
                      />
                      <span className="text-sm font-normal text-gray-700 min-w-[160px]">
                        Correo Electrónico
                      </span>
                      <span className="text-sm font-medium text-gray-800 tracking-wide">
                        {user?.datos?.maskEmail || user?.datos?.email || "u***r@dominio.com"}
                      </span>
                    </label>
                  </div>
                </div>

                {/* Sección Input OTP y Botón Solicitar */}
                <div className="flex flex-col gap-2 pt-2">
                  <div className="text-sm font-medium text-gray-900">
                    Ingrese el código de seguridad recibido:
                  </div>
                  <div className="flex flex-wrap sm:flex-nowrap items-start gap-4">
                    <div className="w-full sm:w-[220px]">
                      <InputGeneric
                        placeholder={""}
                        name={"otp"}
                        type={"text"}
                        handleBlur={handleBlur}
                        onChange={handleChange}
                        errorText={errors.otp}
                        value={form.otp}
                        maxValue={8}
                      />
                    </div>
                    <button
                      type="button"
                      disabled={loadingOtp || (!sendSms && !sendEmail)}
                      onClick={handleSolicitarOtp}
                      className="bg-[#00529C] hover:bg-[#003d75] disabled:bg-gray-400 text-white font-medium text-sm px-6 py-[11px] rounded shadow transition-all duration-200 mt-[2px] whitespace-nowrap"
                    >
                      {loadingOtp ? "Solicitando..." : "Solicitar OTP"}
                    </button>
                  </div>
                </div>

                <div>
                  <p className="text-[0.8rem] text-[#798791] mt-2">
                    {" "}
                    Esta transacción aparecerá en su estado de cuenta como
                    UNONET, S.A., RUC 1977166-1-736409 DV28, sociedad mercantil
                    domiciliada en Panamá, República de Panamá, inscrita ante el
                    Registro Público de Panamá, Sección Mercantil, el 23 de mayo
                    de 2011, ficha N⁰ 736409, Documento Redi N⁰ 1977166, empresa
                    autorizada por NetUno y facilitadora del medio de pago.
                  </p>
                  <p className="text-[0.8rem]  text-[#798791] ">
                    {" "}
                    Los montos cancelados en divisas están sujetos al IGTF de
                    acuerdo a la Gaceta Oficial N° 42.339 de fecha 17-03-2022.
                  </p>
                </div>
                <div className="flex justify-center flex-col items-center gap-2">
                  <div className="flex justify-center  items-center gap-5">
                    <img className="w-[50px] " src={visa} alt="" />
                    <img className="w-[50px] " src={mastercard} alt="" />
                  </div>
                  <div className="flex gap-3 pt-3  flex-col items-center  ">
                    <div className="flex items-start md:items-center gap-3">
                      <input
                        className="mt-[2px] md:m-0"
                        type="checkbox"
                        name="terminos"
                        checked={terminos}
                        onChange={handleTerminos}
                        value={terminos}
                      />
                      <label>
                        {" "}
                        <p className="text-[0.8rem] text-center text-[#798791]">
                          Acepto los{" "}
                          <a
                            target="_blank"
                            className="hover:text-black"
                            href="https://www.netuno.net.ve/cuenta/CONDICIONES_GENERALES_Y_TERMINOS_DE_USO_Y_PRIVACIDAD_NETUNO.pdf"
                          >
                            {" "}
                            <strong>Términos y condiciones </strong>{" "}
                          </a>{" "}
                          {/*  |{" "}
                          <a
                            target="_blank"
                            href="https://www.netuno.net.ve/cuenta/POLITICAS_DE_PRIVACIDAD_NETUNO.pdf"
                            className="hover:text-black"
                          >
                            {" "}
                            <strong>Políticas de Privacidad </strong>{" "}
                          </a>{" "}
                          establecidos.{" "} */}
                        </p>
                      </label>
                    </div>
                    {errorTerminos && (
                      <p className="text-[10px] font-bold text-red-500 ">
                        Debe aceptar los Términos y Condiciones
                      </p>
                    )}
                  </div>
                </div>
                <div>
                  <hr className="pt-[10px] mt-[10px]" />
                  <div className="flex w-full  justify-center items-center  ">
                    <br />
                    {/*!activeForm &&
                      !activeCard &&
                      Object.keys(errors).length === 0 ? (
                      <p className=" text-[10px]  uppercase font-bold text-red-500 ">
                        
                      </p>
                    ) : (
                      ""
                    )*/}
                  </div>
                </div>

                <div className="w-full flex justify-between gap-[50%]">
                  <div className="w-full">
                    <ButtonGeneric funtion={back} text={"Volver"} />
                  </div>
                  <div className="w-full">
                    <ButtonGeneric
                      funtion={pagar}
                      text={"Pagar"}
                      disable={!form.otp || form.otp.toString().trim().length < 6}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="lg:w-[30%] relative sha">
          <div
            className="bg-[#005dff0a] w-full h-[400px] relative flex justify-center rounded-[5%]   before:content-[''] 
                    before:absolute 
                    before:w-[45px] 
                    before:h-[45px] 
                    before:rounded-full 
                    before:bg-white 
                    before:bottom-[-20px]
                    before:left-[-20px]
                   
                    after:content-[''] 
                    after:absolute 
                    after:w-[45px] 
                    after:h-[45px] 
                    after:rounded-full 
                    after:bg-white 
                    after:bottom-[-20px]
                    after:right-[-20px] "
          >
            <div
              className={` bg-[url("../public/bgCard.jpg")] bg-right bg-auto bg-no-repeat w-[80%] flex flex-col justify-between absolute lg:w-[80%] h-[85%] shadow-xl rounded-[10%] top-[-30%] z-[8] p-[2rem]`}
            >
              <div className="flex w-full justify-center absolute top-0  right-0  ">
                <div className="border-blue-500 border-2 shadow-xl w-[30%] shadowTarjet shadow-blue-500 "></div>
              </div>
              <div className="flex justify-center items-center">
                <div className="w-[70%] object-contain">
                  <img
                    className="w-full object-contain "
                    src={data.metodoPago.logo}
                    alt=""
                  />
                </div>
              </div>
              <div className="h-40% grid gap-[10px]">
                <div className="font-medium text-center">
                  {data.metodoPago.title}{" "}
                </div>
                <div className="flex flex-col justify-between items-center">
                  <div className="font-medium text-center ">
                    {" "}
                    <div className="whitespace-nowrap">
                      Número de cuenta
                    </div>{" "}
                  </div>
                  <div className="text-center"> {deatils.nroCuenta} </div>
                </div>
                <div className="flex flex-col justify-between items-center">
                  <div className="font-medium w-full text-center">Moneda</div>
                  <div className=" w-full text-center">
                    {data?.data?.title}{" "}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col justify-end w-full p-5 gap-4">
              <div className="flex justify-between ">
                <div className="text-[#798791] "> {
                  deatils?.deudaTotalVEF < "0" || deatils?.deudaTotalUSD < "0" ?
                    (
                      <>
                        Saldo a favor
                      </>
                    )
                    :
                    (
                      <>
                        Saldo
                      </>
                    )
                }</div>{" "}
                <div className="font-medium">USD {deatils?.deudaTotalUSD} </div>
              </div>
            </div>
          </div>
          <div className="w-full flex justify-center ">
            <div className="w-[80%] border-dashed  border-t-[2px] border-[#c8c8c8]"></div>
          </div>
          <div className="bg-[#005dff0a] h-[100px] rounded-[10%]">
            <div className="w-full p-5 flex justify-between items-center">
              <div>
                <div className="text-[#798791] ">Monto a Pagar</div>
                <div className="text-2xl font-medium">
                  <span className="text-[#798791] pr-2 ">USD</span>
                  {data?.metodoAPagar}
                </div>
              </div>
              <div className="w-[35px] ">
                <img src={bills} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        string={paymentCheck ? "check" : "error"}
        message={paymentMessage}
        active={paymentModal}
        setActive={setPaymentModal}
      >
        <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
          <div className="flex flex-col gap-2">
            <button
              type="button"
              onClick={() => { setPaymentModal(false); setPaymentMessage(""); }}
              className={`${paymentCheck ? "bg-green-500" : "bg-red-500"} inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold text-white shadow-sm sm:ml-3 sm:w-auto`}
            >
              Cerrar
            </button>
          </div>
        </div>
      </Modal>
      <Modal
        active={shoeModal}
        message={message}
        setActive={setShoeModal}
        string={icon ? "check" : "error"}
        loading={loadingModal}
      >
        {loadingModal ? (
          <>
            <div className="w-full h-full flex justify-center  pb-[20px] items-center">
              <Spinner title={"Espere por favor..."} />
            </div>
          </>
        ) : (
          <>
            <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              {deleteCheck ? (
                <>
                  <button
                    type="button"
                    onClick={() => setShoeModal(false)}
                    className="mt-3 inline-flex w-full justify-center rounded-md bg-green-500 px-3 py-2 text-sm font-semibold text-white hover:text-red-500  shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  >
                    Aceptar
                  </button>
                </>
              ) : (
                <>
                  {icon ? (
                    <>
                      <button
                        type="button"
                        onClick={() => deleteTarjeta("borrar")}
                        className="inline-flex w-full justify-center rounded-md bg-green-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                      >
                        Borrar
                      </button>
                      <button
                        type="button"
                        onClick={() => setShoeModal(false)}
                        className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                      >
                        Aceptar
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        type="button"
                        onClick={() => setShoeModal(false)}
                        className="mt-3 inline-flex w-full justify-center rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white hover:text-red-500  shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                      >
                        Aceptar
                      </button>
                    </>
                  )}
                </>
              )}
            </div>
          </>
        )}
      </Modal>
      <Modal active={modalCard} setActive={setModalCard}>
        <button
          type="button"
          onClick={() => setModalCard(false)}
          className="mt-3 inline-flex absolute top-[10px] right-[10px] w-full justify-center rounded-md bg-red-500 px-3 py-2 text-sm font-semibold text-white hover:text-red-500  shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
        >
          x
        </button>
        <CreditCardForm />
      </Modal>
    </>
  );
}

export default TarjetaCreditoEX;
